module.exports = __webpack_public_path__ + "img/placeholder.7e5a2eed.png";